import { render, staticRenderFns } from "./NotamListView.vue?vue&type=template&id=5d6224d9"
import script from "./NotamListView.vue?vue&type=script&lang=js"
export * from "./NotamListView.vue?vue&type=script&lang=js"
import style0 from "./NotamListView.vue?vue&type=style&index=0&id=5d6224d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports